import { useRootStore } from './useRootStore'

export function useClientDetails() {
  const {
    rootStore: { clientDetailsStore }
  } = useRootStore()

  return clientDetailsStore?.clientDetails
}

export function useIsClientDetailsFetched() {
  const {
    rootStore: { clientDetailsStore }
  } = useRootStore()
  return clientDetailsStore?.clientDetailsFetched || false
}
